import styled, { css } from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';
import { fontBody, fontTitle } from 'Styles/fonts';
import { white, black, bombasCream, green, red } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';

import ButtonIconOriginal from '../Icons/ButtonIcon';
import ButtonOriginal from '../Button/Button';

export const CloseButton = styled(ButtonIconOriginal).attrs({
  variant: 'secondary',
  isGhost: true,
  name: 'close'
})`
  position: absolute;
  right: 0;
  top: 4px;
  min-height: 40px;
  height: 40px;
  min-width: 40px;
  width: 40px;
  color: ${white};
`;

export const NotificationContainer = styled.div`
  position: fixed;
  z-index: 1300;
  left: 0;
  width: 100%;
  bottom: 0;

  transition: bottom ${({ transitionDuration }) => transitionDuration}ms
    cubic-bezier(0.25, 1, 0.25, 1);

  &.fade-appear,
  &.fade-enter {
    bottom: -200px;
  }
  &.fade-appear-active,
  &.fade-enter-active {
    bottom: 0;

    ${breakpoint('medium')} {
      bottom: 16px;
    }
  }
  &.fade-exit {
    bottom: 0;

    ${breakpoint('medium')} {
      bottom: 16px;
    }
  }
  &.fade-exit-active {
    bottom: -200px;
  }

  ${breakpoint('medium')} {
    width: auto;
    left: 16px;
    bottom: 16px;
  }
`;

export const Notification = styled.div`
  width: 100%;
  ${({ isFull }) => {
    if (isFull) {
      return 'display: block';
    }
    return css`
      display: flex;
      justify-content: center;
    `;
  }};
  padding: 16px 16px 24px 16px;
  position: relative;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  ${switchProp('variant', {
    info: css`
      background: ${bombasCream};
      color: ${black};

      ${CloseButton} {
        color: ${black};
      }
    `,
    success: css`
      background: ${green};
      color: ${white};
    `,
    error: css`
      background: ${red};
      color: ${white};
    `
  })}

  ${breakpoint('medium')} {
    ${({ isFull }) => {
      if (!isFull) {
        return 'width: 400px';
      }
    }};
    padding-bottom: 16px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;

export const NotificationContent = styled.div`
  max-width: 528px;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const Title = styled.h1`
  ${fontTitle(16)};
  margin: 0;
  padding: 0;

  ${({ $fontWeight }) =>
    $fontWeight &&
    css`
      font-weight: ${$fontWeight};
    `}
`;

export const Body = styled.p`
  ${fontBody(14)};
  margin: 0;
  padding: 0;
  margin-top: 8px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: ${ifProp('hasStackedBtns', 'column', 'row')};
  margin-top: 16px;

  ${({ hide }) =>
    hide &&
    css`
      display: none;
    `}
`;

export const TitleLink = styled.p`
  ${fontBody(16)}
  color: ${black};
  margin-left: 4px;
`;

export const Button = styled(ButtonOriginal)``;
